import { isDateRangeValue } from "@validereinc/utilities";
import classNames from "classnames/bind";
import React from "react";
import { colours } from "../../constants/colours";
import { Icon } from "../../Icon";
import { DataDisplayWithAdornment } from "../_components/DataDisplayWithAdornment";
import { DateDataDisplay } from "../DateDataDisplay";
import styles from "./DateRangeDataDisplay.module.scss";
import type { DateRangeDataDisplayProps } from "./types";

const cx = classNames.bind(styles);

const DateRangeDataDisplay = ({
  value,
  parseFormat,
  divider = "to",
  alignment,
  isInline,
  isBusy,
  isLoading,
  emptyText = "-",
  showInvalidIndicator = true,
  invalidText = "Unsupported data type",
  className,
  style,
  as = "p",
  ...restProps
}: DateRangeDataDisplayProps) => {
  const isDateRange = isDateRangeValue(value, parseFormat);
  const trueValue = isDateRange ? value : null;
  // @ts-expect-error empty string comparison is on purpose
  const isEmpty = value === "" || value === undefined || value === null;
  const isInvalid = trueValue === null || !isDateRange;

  return (
    <DataDisplayWithAdornment
      showAdornment={showInvalidIndicator && !isEmpty && isInvalid}
      alignment={alignment}
      isInline={isInline}
      isBusy={isBusy}
      isLoading={isLoading}
      adornmentSlot={({ iconProps, className }) => (
        <span className={className}>
          <Icon
            {...iconProps}
            variant="warning"
            colour={colours.status.warning}
            alt={invalidText}
            aria-roledescription="Warning Icon"
          />
        </span>
      )}
      className={cx("container", className, isInline && "is-inline")}
      style={style}
      as={as}
    >
      {isEmpty || isInvalid ? (
        emptyText
      ) : (
        <>
          <DateDataDisplay
            value={trueValue.from}
            parseFormat={parseFormat}
            isInline={isInline}
            isBusy={isBusy}
            isLoading={isLoading}
            invalidText={invalidText}
            as="span"
            className={cx("date-part")}
            {...restProps}
          />
          {trueValue.to ? (
            <>
              &nbsp;{divider}&nbsp;
              <DateDataDisplay
                value={trueValue.to}
                parseFormat={parseFormat}
                isInline={isInline}
                isBusy={isBusy}
                isLoading={isLoading}
                invalidText={invalidText}
                as="span"
                className={cx("date-part")}
                {...restProps}
              />
            </>
          ) : null}
        </>
      )}
    </DataDisplayWithAdornment>
  );
};

export default DateRangeDataDisplay;
